import { InputBase } from "@mui/material";
import { styled } from "@mui/material/styles";

import { useTypedTheme } from "hooks";
import { palette } from "theme/palette";

export const Input = styled(InputBase)(() => {
  const { theme } = useTypedTheme();

  const {
    typography: { fieldText },
  } = theme;

  return {
    width: "100%",
    height: 60,
    backgroundColor: palette.white,
    border: `1px solid ${palette.grey}`,
    borderRadius: 10,
    paddingLeft: 22,
    ...fieldText,
    "&.Mui-focused": {
      border: `1px solid ${palette.accent}`,
    },
    "&.Mui-disabled ": {
      backgroundColor: palette.lightGrey,
    },
    "&.Mui-error": {
      border: `1px solid ${palette.error}`,
    },
    "&::placeholder": {
      color: "#d31d1d", // Set your desired placeholder color
    },
  };
});
